import { stack } from './stack';
import { column } from './column';
export const CalendarEventOverlapModes = {
  stack,
  column
};
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./node_modules/vuetify/lib/components/VCalendar/modes/index.js